<div class="flex justify-center">
    <div class="inline-block shadow-2xl rounded-lg overflow-hidden text-center bg-white/40 dark:bg-black/40">
        <img src="league/BPV-Logo-White-v1.png" alt="BPV Logo" width="200" class="mt-3 mx-auto" />
        <div class="px-10 py-2">
            <h2 class="logo-text-header text-2xl font-bold mb-6 -rotate-[3deg]">Season 6</h2>
        </div>
        <div class="px-10 mb-5">
            <p class="mb-1"><b>Renntag:</b> Sonntags (alle 14 Tage)</p>
            <p class="mb-1"><b>Startzeit:</b> 20:30 Uhr</p>
            <p class="mb-1"><b>Training / Qualifying / Rennen</b></p>
            <p class="mb-1"><b>Renndauer:</b> ~60 Minuten</p>
            <p class="mb-1"><b>Autos:</b> Gruppe 3</p>
            <p class="mb-1"><b>Limitierung:</b> BOP, Bremsbalance erlaubt</p>
            <p class="mt-2 mb-1">Die Ligarennen werden live kommentiert und auf Twitch gestreamt</p>
        </div>
    </div>
</div>
